import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";

const NoAuth = () => {
    const { t } = useTranslation("translation");
    const history = useHistory();
    const [message, setMessage] = useState("");

    useEffect(() => {
        const storedMessage = localStorage.getItem("forbiddenMessage");
        if (storedMessage) {
            setMessage(storedMessage);
            localStorage.removeItem("forbiddenMessage");
        } else {
            setMessage(t("NoRight"));
        }
    }, [t]);

    return (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h1>{t("NoRight")}</h1>
            {/* <p style={{ marginTop: "24px", fontSize: "1rem", color: "#666" }}>{message}</p> */}
            <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "32px" }}
                onClick={() => history.push("/")}
            >
                {t("GoHome", "Home")}
            </Button>
        </div>
    );
};

export default NoAuth;
